<ng-container *transloco="let t">
  <div
    #componentWrapper
    class="content"
    [class.widescreen]="(biggerThan$ | async)?.sm"
    [class.single-header]="(biggerThan$ | async)?.mobileL">
    <div #scrollElement class="main-scroll" id="mainAppScroll" cdk-scrollable>
      <main class="wrapper">
        <!--Products Link Bar -->
        @if ((biggerThan$ | async)?.mobileL) {
          <app-navigation-bar />
        }
        <!-- Banner -->
        <app-carousel-banner />
        <app-highlights-banner />

        <app-best-sellers-picker />

        <!-- Category Picker -->
        <!-- Best Sellers Picker -->
        @defer (on viewport; on timer(10s); when isRestoringScroll()) {
          <app-category-picker class="category-picker"></app-category-picker>
        } @placeholder {
          <app-ui-skeleton />
        } @error {
          <span>loading</span>
        }

        <!-- Coming Soon Banner -->
        @if (enableBuybackFeature() === true) {
          @defer (on viewport; when isRestoringScroll() === true) {
            <app-coming-soon-banner />
          } @placeholder {
            <app-ui-skeleton />
          } @error {
            <span>loading</span>
          }
        }

        <!--         <span class="fixed-space-32" aria-hidden="true"></span>
 -->
        <!-- Pick up where you left Banner -->
        @defer (on viewport; when isRestoringScroll() === true) {
          <app-last-added-picker />
        } @placeholder {
          <app-ui-skeleton />
        } @error {
          <span>loading</span>
        }

        <!-- <span class="fixed-space-32" aria-hidden="true"></span>

        @defer (on viewport; on timer(10s)) {
          <app-motivation-banner />
        } @placeholder {
          <app-ui-skeleton />
        } -->

        <!--         <span class="fixed-space-32" aria-hidden="true"></span>
 -->

        <!--         <span class="fixed-space-32" aria-hidden="true"></span>
 -->
        <!-- Best Brands Picker -->
        @defer (on viewport; on timer(10s); when isRestoringScroll() === true) {
          <app-best-brands-picker />
        } @placeholder {
          <app-ui-skeleton />
        } @error {
          <span>loading</span>
        }

        <!--         <span class="fixed-space-32" aria-hidden="true"></span>
 -->
        @defer (on viewport; on timer(10s); when isRestoringScroll() === true) {
          <app-subscription-banner />
        } @placeholder {
          <app-ui-skeleton />
        } @error {
          <span>loading</span>
        }

        <!-- Benefits Banner -->
        @defer (on viewport; on timer(10s); when isRestoringScroll() === true) {
          <app-benefits-banner />
        } @placeholder {
          <app-ui-skeleton />
        } @error {
          <span>loading</span>
        }

        @defer (on viewport; on timer(10s); when isRestoringScroll() === true) {
          <app-social-videos-banner />
        } @placeholder {
          <app-ui-skeleton />
        } @error {
          <span>loading</span>
        }

        <!--         <span class="fixed-space-32" aria-hidden="true"></span>
 -->
        <!-- Reviews Banner -->
        @defer (on viewport; when isRestoringScroll() === true) {
          <app-reviews-banner />
        } @placeholder {
          <app-ui-skeleton />
        } @error {
          <span>loading</span>
        }

        <!-- Feedback Banner -->
        @defer (on viewport; when isRestoringScroll() === true) {
          <app-feedback-banner />
        } @placeholder {
          <app-ui-skeleton />
        } @error {
          <span>loading</span>
        }
      </main>
      <span class="fixed-space-32" aria-hidden="true"></span>
      <app-footer></app-footer>
    </div>
  </div>
</ng-container>
